//
// scheduler-form.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*jshint jquery: true */
/*global angular: false, _: false, moment: false */

(function () {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.directive('schedulerForm', ['DateTimeService', 'EnvironmentService', 'ErrorNotificationService', 'ImageService', 'ProductTaggingService', 'SchedulerService', 'SessionVarsService', 'TaggerSanitization', 'TrackingService', 'UniversalImageActionsHelpers', 'UniversalImageActionsItemType', 'UniversalImageActionsService', 'UrlUtils',
        function (DateTimeService, EnvironmentService, ErrorNotificationService, ImageService, ProductTaggingService, SchedulerService, SessionVarsService, TaggerSanitization, TrackingService, UniversalImageActionsHelpers, UniversalImageActionsItemType, UniversalImageActionsService, UrlUtils) {
            return {
                restrict: 'E',
                scope: {
                    buffers: '=',
                    boards: '=',
                    devices: '=',
                    backToSelectionsCallback: '&',
                    imageScheduledCallback: '&'
                },
                templateUrl: EnvironmentService.getTemplateRootDirectory() + 'scheduler/scheduler-form.html',
                replace: true,
                controller: ['$rootScope', '$scope',
                    function($rootScope, $scope) {
                        var getPageCount, updateUnscheduledCount, updateScheduleButtonTooltip, hasValidPinterestDescription, hasValidPinterestSize,
                            trackingCode, addFieldsToSavedImage, initializeScheduler;

                        // DO NOT CHANGE: Using 'BulkScheduler' for consistency with old tracking data.
                        trackingCode = TrackingService.CATEGORY_SCHEDULER;

                        $scope.scheduler = {
                            initialized: false, // set to true after data has loaded and we can display the page
                            unscheduledCount: 0,
                            submitted: false,
                            submitError: null,
                            spinRefreshBoards: false,
                            outstandingAsyncAction: null,
                            savedImages: [],
                            savedImagesByPage: [],
                            page: 0,
                            pageCount: 1,
                            selectedItem: null,
                            PAGE_SIZE: 12,
                            bufferSelectedId: null,
                            pinterestUsername: SessionVarsService.getPinterestUsername(),
                            like2BuyEnabled: SessionVarsService.isFeatureEnabled('like2buy'),
                            isMobileTaggingEnabled: SessionVarsService.isFeatureEnabled('mobile_product_tagging'),
                            syndicationEnabled: SessionVarsService.isFeatureEnabled('syndication'),
                            like2BuyMultiproductEnabled: SessionVarsService.isFeatureEnabled('like2buy_multiproduct'),
                            isUiaEnabled: SessionVarsService.isFeatureEnabled('universal_image_actions'),
                            isVideoSchedulingEnabled: SessionVarsService.isFeatureEnabled('instagram_video_scheduling'),
                            mobileConfig: {
                                suppressInstagramPostNotification: true
                            }
                        };

                        addFieldsToSavedImage = function(elt, idx) {
                            var initialTime;
                            // Initialize the manual schedule time in the date picker to the next hour.
                            initialTime = DateTimeService.roundNow().add(1, 'h');
                            elt.scheduled = false;
                            elt.displayOrder = idx;
                            elt.selected = false;
                            elt.time = initialTime.toDate();
                            elt.shouldManualSchedule = false;
                            elt.postNow = false;
                            elt.postedNow = false;
                            elt.tags = elt.tags ? elt.tags : [];
                            elt.img = null;

                            // TODO: Eventually support selecting product urls from a dropdown, for now we'll just automatically choose the first url
                            elt.like2BuyUrl = elt.like2BuyUrl || ((elt.productsData && elt.productsData.length > 0) ? elt.productsData[0].url : '');
                        };

                        initializeScheduler = function() {
                            $scope.setPage(0);
                            updateUnscheduledCount();
                            $scope.scheduler.initialized = true;
                            $scope.scheduler.pageCount = getPageCount();
                        };

                        getPageCount = function() {
                            return Math.ceil($scope.scheduler.savedImages.length / $scope.scheduler.PAGE_SIZE);
                        };

                        updateUnscheduledCount = function() {
                            $scope.scheduler.unscheduledCount = _.where($scope.scheduler.savedImages, { scheduled: false }).length;
                        };

                        updateScheduleButtonTooltip = function() {
                            var item = $scope.scheduler.selectedItem;

                            if (!item) {
                                return;
                            }

                            if (item.shouldManualSchedule) {
                                item.scheduleTooltip =
                                    "Schedule this post for:<br />" + $scope.formatScheduleTime();
                            } else {
                                item.scheduleTooltip =
                                    "<span class='schedule-time-tooltip'>" +
                                    "The selected Buffer's Auto&#8209;Schedule settings will be used to determine when the Pin is posted" +
                                    "</span>";
                            }
                        };

                        $scope.getItemType = function(itemId) {
                            if (!itemId) {
                                return null;
                            } else if (itemId.indexOf("mis") === 0) {
                                return UniversalImageActionsItemType.mediaItem;
                            } else {
                                return UniversalImageActionsItemType.savedImage;
                            }
                        };

                        hasValidPinterestDescription = function(description) {
                            return !description || description.length <= 500;
                        };

                        hasValidPinterestSize = function(sizeInBytes) {
                            return !sizeInBytes || sizeInBytes <= 10000000; // 10MB
                        };

                        $scope.$watch('scheduler.selectedItem.shouldManualSchedule', function() {
                            updateScheduleButtonTooltip();
                        });

                        $scope.$watch('scheduler.selectedItem.scheduled', function() {
                            updateScheduleButtonTooltip();
                        });

                        $scope.$watch('scheduler.bufferSelectedId', function(newVal, oldVal) {
                            var buffer, noExistingProducts, supportsLoadingSavedProducts;

                            if (newVal) {
                                buffer = _.findWhere($scope.buffers, { id: parseInt(newVal, 10) });
                                $scope.scheduler.selectedItem.buffer = buffer;

                                noExistingProducts = !$scope.scheduler.selectedItem.products || $scope.scheduler.selectedItem.products.length === 0;
                                supportsLoadingSavedProducts = $scope.scheduler.isUiaEnabled || ($scope.scheduler.syndicationEnabled && !$scope.scheduler.selectedItem.syndicationProdAssigned);

                                if (buffer.network === 'Instagram' && noExistingProducts && supportsLoadingSavedProducts) {
                                    SchedulerService.getSavedImageProductsAsync($scope.scheduler.selectedItem.id).then(function (result) {
                                        var positionIncrement, savedImageProducts;
                                        positionIncrement = 1;

                                        if ($scope.scheduler.selectedItem.products === undefined) {
                                            $scope.scheduler.selectedItem.products = [];
                                        } else {
                                            positionIncrement = positionIncrement + $scope.scheduler.selectedItem.products.length;
                                        }

                                        savedImageProducts = _(result.SavedImageProducts).map(function (sip) {
                                            sip.imageUrl = sip.selectedImageUrl;
                                            sip.sourceImageUrl = sip.selectedImageUrl;
                                            sip.position = positionIncrement;
                                            sip.id = undefined; // Unset the id field ; leaving this set causes the tagging service to try to update
                                            // the product tag with the same id, instead of adding a new product tag

                                            positionIncrement = positionIncrement + 1;
                                            return sip;
                                        });

                                        $scope.scheduler.selectedItem.products.push.apply($scope.scheduler.selectedItem.products, savedImageProducts);
                                        $scope.scheduler.selectedItem.syndicationProdAssigned = true;
                                    });
                                }
                            } else if (oldVal) {
                                $scope.scheduler.selectedItem.buffer = null;
                            }

                            // reset instagramDimension validation when switching buffers
                            $scope.scheduleForm.$setValidity('instagramDimensions', true);
                        });

                        $scope.backToSelections = function() {
                            if (!$scope.scheduler.fatalError) {
                                $scope.clear();
                                $scope.backToSelectionsCallback();
                            }
                        };

                        $scope.shouldDisableForm = function() {
                            // Disable the form during async actions, page load, and if the item was already "posted now"
                            return $scope.buffers.length === 0 ||
                                $scope.scheduler.outstandingAsyncAction ||
                                !$scope.scheduler.selectedItem ||
                                $scope.scheduler.selectedItem.postedNow ||
                                $scope.scheduler.fatalError;
                        };

                        $scope.close = function() {
                            window.close();
                        };

                        $scope.clear = function() {
                            $scope.scheduler.savedImages = [];
                        };

                        $scope.beautifySaveClicked = function(newUrl) {
                            var item, previousImageUrl, data;

                            item = $scope.scheduler.selectedItem;
                            previousImageUrl = item.imageUrl;
                            data = {
                                imageUrl : newUrl
                            };

                            TrackingService.recordEvent(trackingCode, 'Beautify');

                            $scope.scheduler.outstandingAsyncAction = 'beautify';
                            return SchedulerService.updateSavedImageAsync(item.id, data).then(function() {
                                // note: We could update the client model so that the image urls point to their updated s3 locations,
                                // but directly referencing the aviary url is fine in this scenario (only used for lifetime of the page).
                                item.imageUrl = newUrl;
                                item.thumbnailUrl = newUrl;

                                if (!item.revertBeautifyUrl) {
                                    item.revertBeautifyUrl = previousImageUrl;
                                }

                                // reset instagram dimensions error if it was showing
                                $scope.scheduleForm.$setValidity('instagramDimensions', true);
                            }).finally(function() {
                                $scope.scheduler.outstandingAsyncAction = null;
                            });
                        };

                        $scope.selectBoard = function(value) {
                            var board;
                            if (value) {
                                $scope.scheduleForm.$setValidity('pinterestBoardSelected', true);
                                board = _.findWhere($scope.boards, {id: value});
                            } else {
                                $scope.scheduleForm.$setValidity('pinterestBoardSelected', false);
                            }

                            $scope.scheduler.selectedItem.pinterestBoard = {id: value, name: board ? board.name : null};
                        };

                        $scope.revertBeautifyClicked = function() {
                            var item, data;

                            item = $scope.scheduler.selectedItem;
                            data = {
                                imageUrl : item.revertBeautifyUrl
                            };

                            TrackingService.recordEvent(trackingCode, 'RevertBeautify');

                            $scope.scheduler.outstandingAsyncAction = 'beautify';
                            SchedulerService.updateSavedImageAsync(item.id, data).then(function() {
                                item.imageUrl = item.revertBeautifyUrl;
                                item.thumbnailUrl = item.revertBeautifyUrl;
                                item.revertBeautifyUrl = null;
                            }).finally(function() {
                                $scope.scheduler.outstandingAsyncAction = null;
                            });
                        };

                        // Instagram images need to be cropped to acceptable dimensions (via beautify)
                        $scope.getForceCropRatio = function() {
                            var item = $scope.scheduler.selectedItem;

                            if (item) {
                                return SchedulerService.getForceCropRatio(item, item.imageDimensions)
                            } else {
                                return null;
                            }
                        };

                        $scope.scheduleCurrentItem = function(suppressInstagramPostNotification) {
                            var item, promise, chainedPromiseResult, scheduleForm, scheduleDate, selectedProducts, scheduleType, scheduleArgs,
                                SCHEDULE_TYPE_AUTO, SCHEDULE_TYPE_MANUAL, SCHEDULE_TYPE_POST_NOW;

                            // Constants from SchedulePin.scala
                            SCHEDULE_TYPE_AUTO = 'auto';
                            SCHEDULE_TYPE_MANUAL = 'manual';
                            SCHEDULE_TYPE_POST_NOW = 'now';

                            $scope.scheduler.submitError = null;
                            $scope.scheduler.submitted = true;
                            scheduleForm = $scope.scheduleForm;

                            // Reset manual form validations
                            scheduleForm.$setValidity('disallowPastTimes', true);
                            scheduleForm.$setValidity('instagramDimensions', true);
                            scheduleForm.$setValidity('instagramDuration', true);
                            scheduleForm.$setValidity('pinterestVideo', true);
                            scheduleForm.$setValidity('pinterestFileSize', true);
                            scheduleForm.$setValidity('pinterestDescriptionMaxLength', true);
                            scheduleForm.$setValidity('pinterestBoardSelected', true);
                            scheduleForm.$setValidity('invalidTags', true);
                            scheduleForm.$setValidity('expiredBuffer', true);

                            if (scheduleForm.$valid) {
                                item = $scope.scheduler.selectedItem;
                                promise = null;
                                chainedPromiseResult = null;
                                scheduleDate = DateTimeService.formatUserMoment(item.time);
                                scheduleType = item.postNow ? SCHEDULE_TYPE_POST_NOW : (item.shouldManualSchedule ? SCHEDULE_TYPE_MANUAL : SCHEDULE_TYPE_AUTO);
                                selectedProducts = ProductTaggingService.getProducts();
                                _(selectedProducts).each(function(product) {
                                    product.id = null;
                                });
                                scheduleArgs = {
                                    bufferItem: {
                                        bufferId: parseInt(item.buffer.id),
                                        bufferName: item.buffer.name,
                                        description: item.description,
                                        fileId: item.fileId,
                                        imageUrl: item.imageUrl,
                                        id: item.scheduledItemId,
                                        products: selectedProducts,
                                        scheduleDateTime: scheduleDate,
                                        scheduleType: scheduleType,
                                        thumbnailImageUrl: item.thumbnailUrl,
                                        universalItemId: $scope.scheduler.universalItemId
                                    },
                                    savedImageId: item.id,
                                    tags: item.tags
                                };

                                // Do not allow auto-scheduling to an expired buffer
                                if ((scheduleType === SCHEDULE_TYPE_AUTO) && item.buffer.endDate) {
                                    if (DateTimeService.userToday() >= DateTimeService.userMoment(item.buffer.endDate).startOf('day').add(1, 'days')) {
                                        scheduleForm.$setValidity('expiredBuffer', false);
                                        return;
                                    }
                                }

                                if (item.buffer.network === 'Pinterest') {
                                    if (!item.pinterestBoard || !item.pinterestBoard.id) {
                                        scheduleForm.$setValidity('pinterestBoardSelected', false);
                                        return;
                                    }

                                    scheduleArgs.bufferItem.pinterestOptions = {
                                        boardId: item.pinterestBoard.id,
                                        destinationUrl: item.source
                                    };

                                    if (!hasValidPinterestDescription(item.description)) {
                                        scheduleForm.$setValidity('pinterestDescriptionMaxLength', false);
                                        return;
                                    }

                                    if (!hasValidPinterestSize(item.fileSize)) {
                                        scheduleForm.$setValidity('pinterestFileSize', false);
                                        return;
                                    }

                                    if (!!item.videoId) {
                                        scheduleForm.$setValidity('pinterestVideo', false);
                                        return;
                                    }

                                } else if (item.buffer.network === 'Instagram') {
                                    scheduleArgs.mobileDeviceId = item.instagramDevice.id;
                                    scheduleArgs.suppressInstagramPostNotification = item.postNow && suppressInstagramPostNotification;

                                    if (!item.videoId && !SchedulerService.hasValidInstagramDimensions(item.imageDimensions, item.imageRatio)) {
                                        scheduleForm.$setValidity('instagramDimensions', false);
                                        return;
                                    }

                                    if (!!item.videoId && !!item.videoDuration && !SchedulerService.hasValidVideoDuration(item.videoDuration)) {
                                        scheduleForm.$setValidity('instagramDuration', false);
                                        return;
                                    }

                                    scheduleArgs.bufferItem.instagramOptions = {
                                        mobileDeviceId: item.instagramDevice.id,
                                        like2BuyUrl: UrlUtils.cleanUrl(item.like2BuyUrl)
                                    };
                                }

                                // Workaround for timepicker not having min date form validation
                                if ((scheduleType === SCHEDULE_TYPE_MANUAL) && (item.time < new Date())) {
                                    scheduleForm.$setValidity('disallowPastTimes', false);
                                    return;
                                }

                                // Check the tags are valid - if not bubble up an error
                                var allValid = item.tags.every(function(elem) {
                                    return TaggerSanitization.valid(elem);
                                });
                                if (!allValid) {
                                    scheduleForm.$setValidity('invalidTags', false);
                                    return;
                                }

                                $scope.scheduler.outstandingAsyncAction = 'schedule';

                                TrackingService.recordEvent(trackingCode,
                                                            'Schedule',
                                                            'Schedule=' + scheduleType + ',Network=' + item.buffer.network + (item.videoId ? ',video' : ''));
                                promise = SchedulerService.scheduleAsync(item.buffer.id, scheduleArgs).then(function(result) {
                                    item.scheduledItemId = result.id;

                                    // Save tags used for scheduling so that users aren't confused by the async
                                    // re-fetching of tags for the newly scheduled post.
                                    result.tagsFromScheduler = scheduleArgs.tags;

                                    return result;
                                });

                                /**
                                 * This logic was used to support Like2Buy v1's destination_url. The Dashboard has been
                                 * updated at this point to support multiproduct-tagging and has special logic for the
                                 * "exactly 1 product" case, but mobile still uses a destination_url field. As soon as
                                 * all clients have upgraded to "mobile_product_tagging" this code block can all be removed.
                                 */
                                if (!$scope.scheduler.isMobileTaggingEnabled && SessionVarsService.isMobile() && $scope.scheduler.like2BuyMultiproductEnabled && item.buffer.network === 'Instagram') {
                                    var productUpdateArgs = null;

                                    // Check if any products were added at creation.
                                    if (item.products && item.products.length > 0) {
                                        // Desktop app supports multiple products.
                                        productUpdateArgs = {
                                            products: item.products
                                        };
                                    } else if (item.legacyProductUrl) {
                                        // Mobile scheduler form only supports adding one product.
                                        productUpdateArgs = {
                                            products: [{
                                                destinationUrl: UrlUtils.cleanUrl(item.legacyProductUrl),
                                                position: 1
                                            }]
                                        };
                                    }

                                    // If products were added at creation attempt to update the products list for the newly created buffer item.
                                    if (productUpdateArgs) {
                                        promise = promise.then(function(result) {

                                            // We need to save the result from the scheduleAsync call so we can use it after the promise from
                                            // updateBufferItemProductsAsync completes. Updating products and the buffer item should be atomic.
                                            // TODO: Factor out this promise chaining when DEV-7427 is complete which adds 'products' as a data
                                            // parameter for scheduleAsync.
                                            chainedPromiseResult = result;

                                            // We chain the promises this way so that errors from scheduleAsync and updateBufferItemProductsAsync
                                            // are both handled by the sole catch and finally statements.
                                            return SchedulerService.updateBufferItemProductsAsync(item.buffer.id, result.id, productUpdateArgs);
                                        });
                                    }
                                }

                                if (item.tags.length > 0) {
                                    TrackingService.recordEvent(trackingCode, 'BrandTags', 'Count=' + item.tags.length, item.tags.length);
                                }

                                promise.then(function(response) {
                                    var index, newPageCount, indexToAdd;

                                    if (chainedPromiseResult) {
                                        // Returning from updating the products list.
                                        // We need to copy over the new product id or subsequent update requests will actually delete the product.
                                        chainedPromiseResult.products = response.products;
                                        item.products = response.products;
                                        response = chainedPromiseResult;

                                        // Clear out the legacy product url or this will show again if the text is deleted and the product is updated.
                                        item.legacyProductUrl = "";
                                    }

                                    // Remove the item and then select the next item
                                    index = $scope.scheduler.savedImages.indexOf(item);
                                    $scope.scheduler.savedImages.splice(index, 1);

                                    index = $scope.scheduler.savedImagesByPage.indexOf(item);
                                    $scope.scheduler.savedImagesByPage.splice(index, 1);

                                    updateUnscheduledCount();

                                    // Select the next item. If the deleted item was the last one on a page, transition to previous page
                                    newPageCount = getPageCount();
                                    if ($scope.scheduler.pageCount !== newPageCount) {
                                        $scope.scheduler.pageCount = newPageCount;
                                        $scope.setPage($scope.scheduler.pageCount - 1);
                                    } else {
                                        // Still on the same page, if we're not on the last page backfill an item to keep the page filled.
                                        if ($scope.scheduler.page !== ($scope.scheduler.pageCount - 1)) {
                                            indexToAdd = (($scope.scheduler.page + 1) * $scope.scheduler.PAGE_SIZE) - 1;
                                            if (indexToAdd !== ($scope.scheduler.savedImages.length - 1)) {
                                                $scope.scheduler.savedImagesByPage.push($scope.scheduler.savedImages[indexToAdd]);
                                            }
                                        }

                                        // Clear outstandingAsyncAction so that selecting the next item doesn't get blocked.
                                        $scope.selectNextItem();
                                    }

                                    $scope.imageScheduledCallback({
                                        image: response,
                                        savedImageId: item.id,
                                        unscheduledCount: $scope.scheduler.unscheduledCount
                                    });

                                    // Let others know that we have successfully scheduled an item
                                    $rootScope.$emit('scheduler:BufferItemsModified');

                                    if (item.postNow && item.buffer.network === 'Instagram') {
                                        $scope.$emit('mobile:PostNowInstagram', response);
                                    }

                                    // Clear outstandingAsyncAction to allow selection of the next item.
                                    $scope.scheduler.outstandingAsyncAction = null;
                                    $scope.selectNextItem();
                                }).catch(function(error) {
                                    if (!error) {
                                        $scope.scheduler.fatalError = true;
                                        error = 'An unexpected error occurred while attempting to schedule your post. Please wait a few minutes, then refresh the page and try again.';
                                    }

                                    $scope.scheduler.submitError = error;
                                }).finally(function() {
                                    $scope.scheduler.outstandingAsyncAction = null;
                                    $scope.scheduler.submitted = false;
                                });
                            }
                        };

                        $scope.selectNextItem = function() {
                            var item, nextItem;

                            item = $scope.scheduler.selectedItem;

                            nextItem = _.find($scope.scheduler.savedImages, function(savedImage) {
                                return !savedImage.scheduled && savedImage.displayOrder > item.displayOrder;
                            });

                            // If there are no items after the current one, select the final item.
                            if (!nextItem && ($scope.scheduler.savedImages.length > 0)) {
                                nextItem = _.last($scope.scheduler.savedImages);
                            }

                            $scope.setSelectedItem(nextItem);
                        };

                        $scope.setSelectedItem = function(item) {
                            var idx, startIndex, prevItem, prevItemHasValues, nextItemUnmodified, image;

                            if ($scope.scheduler.fatalError) {
                                return;
                            }

                            // Don't allow switching items while async actions are still taking place, and ignore
                            // the item change if it's to the current item.
                            if ((item === $scope.scheduler.selectedItem) || $scope.scheduler.outstandingAsyncAction) {
                                return;
                            }

                            // Reset displayed errors when user switches items
                            $scope.scheduler.submitError = null;
                            $scope.scheduler.submitted = false;

                            if ($scope.scheduler.selectedItem) {
                                $scope.scheduler.selectedItem.selected = false;
                            }

                            // If the item isn't on the current page, move to that item's page.
                            if (!_.contains($scope.scheduler.savedImagesByPage, item)) {
                                idx = _.indexOf($scope.scheduler.savedImages, item);
                                $scope.scheduler.page = Math.floor(idx / $scope.scheduler.PAGE_SIZE);

                                startIndex = $scope.scheduler.page * $scope.scheduler.PAGE_SIZE;
                                $scope.scheduler.savedImagesByPage = $scope.scheduler.savedImages.slice(startIndex, startIndex + $scope.scheduler.PAGE_SIZE);
                            }

                            // Auto-initialize properties of the selected item using values from the previous, if they haven't already been set.
                            // This streamlines the experience when scheduling a lot of things to the same place.
                            prevItem = $scope.scheduler.selectedItem;
                            prevItemHasValues = prevItem && prevItem.buffer;
                            nextItemUnmodified = item && !item.buffer && !item.pinterestBoard && !item.instagramDevice;
                            if (prevItemHasValues && nextItemUnmodified) {
                                item.buffer = prevItem.buffer;
                                if (prevItem.buffer.network === 'Pinterest') {
                                    item.pinterestBoard = prevItem.pinterestBoard;
                                } else if (prevItem.buffer.network === 'Instagram') {
                                    item.instagramDevice = prevItem.instagramDevice;
                                }
                            }

                            // Ensure we have some notion of dimension ratio for validation
                            if (item && !item.imageDimensions) {
                                image = new Image(0,0);
                                image.src = item.thumbnailUrl;
                                item.imageRatio = image.naturalWidth / image.naturalHeight;
                            }

                            // Ensure we have some notion of the item's size for validation
                            if (item && !item.fileSize) {
                                ImageService.getFileSize(item.imageUrl).then(function(size) {
                                    item.fileSize = size.bytes;
                                });
                            }

                            // Now actually update the selectedItem
                            $scope.scheduler.selectedItem = item;
                            if (item) {
                                $scope.scheduler.selectedItem.selected = true;

                                // Update this so we programmatically set UIA item type after all clients are migrated
                                // to the Media Import Service.
                                $scope.scheduler.universalItemId = UniversalImageActionsHelpers.itemIdToUniversalItemId(
                                    $scope.getItemType($scope.scheduler.selectedItem.id),
                                    $scope.scheduler.selectedItem.id
                                );

                                UniversalImageActionsService.getItemMetadataAsync($scope.scheduler.universalItemId, /*params*/ null, /*forceRefresh*/ true).then(function (response) {
                                    ProductTaggingService.setProducts(response.productTags, $scope.scheduler.universalItemId);
                                    $scope.scheduler.selectedItem.products = angular.copy(ProductTaggingService.getProducts());
                                });

                                // Messy book keeping because angular ui-select2 is not fully angularified yet.
                                if (item.buffer) {
                                    $scope.scheduler.bufferSelectedId = item.buffer.id;

                                    // Dashboard uses a dropdown for the board selector that does not
                                    // have two way binding so fire a message
                                    if (item.buffer.network === 'Pinterest') {
                                        if (item.pinterestBoard && item.pinterestBoard.id) {
                                            $scope.$broadcast('dropdown:board-selector:changeOption', {
                                                value: item.pinterestBoard.id
                                            });
                                        } else {
                                            $scope.$broadcast('dropdown:board-selector:resetDropdownToDefault');
                                        }
                                    }
                                }
                            }
                        };

                        $scope.formatScheduleTime = function() {
                            if ($scope.scheduler.selectedItem) {
                                return DateTimeService.formatUserMoment($scope.scheduler.selectedItem.time, 'MMM Do, h:mm a');
                            } else {
                                return '';
                            }
                        };

                        $scope.scheduleDateTimeChanged = function(dateTime) {
                            var shouldManualSchedule = dateTime && !isNaN(dateTime.getTime());
                            if ($scope.scheduler.selectedItem) {
                                $scope.scheduler.selectedItem.time = dateTime;
                                $scope.scheduler.selectedItem.shouldManualSchedule = shouldManualSchedule;

                                updateScheduleButtonTooltip();
                            }
                        };

                        $scope.setPage = function(pageNumZeroIndexed) {
                            var startIndex;

                            $scope.scheduler.page = pageNumZeroIndexed;

                            startIndex = $scope.scheduler.page * $scope.scheduler.PAGE_SIZE;
                            $scope.scheduler.savedImagesByPage = $scope.scheduler.savedImages.slice(startIndex, startIndex + $scope.scheduler.PAGE_SIZE);

                            if ($scope.scheduler.savedImagesByPage.length > 0) {
                                $scope.setSelectedItem($scope.scheduler.savedImagesByPage[0]);
                            } else {
                                $scope.setSelectedItem(null);
                            }
                        };


                        $scope.refreshPinterestBoards = function() {
                            TrackingService.recordEvent(trackingCode, 'RefreshPinterestBoards');

                            $scope.scheduler.spinRefreshBoards = true;
                            SchedulerService.getBoardsAsync(true).then(function(data) {
                                $scope.boards = _.sortBy(data.items, 'name');
                            }).catch(function(errorMessage) {
                                ErrorNotificationService.showErrorDialog('Nuts! That didn\'t work...', errorMessage);
                            }).finally(function() {
                                $scope.scheduler.spinRefreshBoards = false;
                            });
                        };

                        $scope.hasValidInstagramDimensions = function(item) {
                            if (!item) {
                                return false;
                            }
                            return SchedulerService.hasValidInstagramDimensions(item.imageDimensions, item.imageRatio)
                        };

                        //
                        // Load the data to display the form
                        //

                        /**
                         * Mobile-specific code for product tagging.
                         *
                         * When we "come back" from the productize view, update this item's products.
                         */
                        $scope.$on('$stateChangeSuccess', function() {
                            $scope.scheduler.selectedItem.products = [];
                            $scope.scheduler.selectedItem.products = angular.copy(ProductTaggingService.getProducts());
                        });

                        $scope.$on('scheduleSelectedImages', function (event, savedImages) {
                            // Clear the selected item and buffer each time the scheduler form
                            // is reloaded so the form, displayed fields, and validation don't
                            // go out of sync.

                            $scope.scheduler.bufferSelectedId = savedImages[0] ? savedImages[0].bufferId : null;
                            $scope.scheduler.selectedItem = null;

                            // Add a few properties for client-side book keeping of each saved image.
                            _.each(savedImages, function(elt, idx) {
                                addFieldsToSavedImage(elt, idx);
                            });

                            $scope.scheduler.savedImages = savedImages;
                            initializeScheduler();

                            // If this is an item that has a selected buffer id, we need to grab the first item's buffer network
                            // and set that after the selectedItem has been set.
                            if ($scope.scheduler.bufferSelectedId) {
                                $scope.scheduler.selectedItem.buffer = _.findWhere($scope.buffers, { id: parseInt($scope.scheduler.bufferSelectedId, 10) });
                            }

                            TrackingService.recordEvent(trackingCode, 'ScheduledImagesPerSession', 'ImageCount=' + savedImages.length, savedImages.length);
                        });

                        $scope.$on('appendSavedImage', function(event, savedImage) {
                            addFieldsToSavedImage(savedImage, $scope.scheduler.savedImages.length);
                            $scope.scheduler.savedImages.unshift(savedImage);
                            initializeScheduler();
                            $scope.scheduler.bufferSelectedId = savedImage.bufferId;
                            if ($scope.scheduler.bufferSelectedId) {
                                $scope.scheduler.selectedItem.buffer = _.findWhere($scope.buffers, { id: parseInt($scope.scheduler.bufferSelectedId, 10) });
                            }
                        });

                        $scope.$on('uia:modal:closed', function($event, response) {
                            var universalItemId = UniversalImageActionsHelpers.parsePartialUniversalItemId(response.universalItemId),
                                itemId = parseInt(universalItemId.itemId, 10),
                                imageToUpdate;

                            if (universalItemId.itemType.toLowerCase() === UniversalImageActionsItemType.savedImage ||
                                universalItemId.itemType.toLowerCase() === UniversalImageActionsItemType.mediaItem ) {
                                imageToUpdate = _($scope.scheduler.savedImages).findWhere({id: itemId});

                                if (response.productsChanged && imageToUpdate) {
                                    imageToUpdate.products = response.products;
                                }

                                if (response.beautifyUrl && imageToUpdate) {
                                    imageToUpdate.imageUrl = response.beautifyUrl;
                                    imageToUpdate.thumbnailUrl = response.beautifyUrl;
                                }
                            }
                        });
                    }
                ]
            };
        }]);

})();
